import StimulusCarousel from '@stimulus-components/carousel'

export default class CarouselStimulusController extends StimulusCarousel {
  static values = {
    slidesPerView: Number,
    navigation: Boolean,
  };

  static targets = ['swiperButtonPrev', 'swiperButtonNext'];

  connect() {
    super.connect();

    this.swiper;

    this.defaultOptions;
  }

  get defaultOptions() {
    const navigationOptions = {
      nextEl: this.swiperButtonNextTarget,
      prevEl: this.swiperButtonPrevTarget,
    };

    return {
      slidesPerView: this.slidesPerViewValue,
      navigation: this.navigationValue ? navigationOptions : false,
      loop: false,
    };
  }
}
